import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa';
import './LanguageSwitcher.css';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  return (
    <button type="button" className="language-switcher-btn" onClick={() => i18n.changeLanguage(isArabic ? 'en' : 'ar')} aria-label={isArabic ? 'Switch to English' : 'التبديل إلى العربية'}>
      <FaGlobe aria-hidden="true" /><span>{isArabic ? 'EN' : 'عربي'}</span>
    </button>
  );
}
